import type { TOC } from '@ember/component/template-only'
import PhosphorIcon from 'teacher-ui-client/components/phosphor-icon'
import { StudentDashboardTile } from 'teacher-ui-client/components/tiles/student-dashboard'
import { DashboardStudentProgressOverview } from 'teacher-ui-client/components/reporting/mathseeds-prime/dashboard-student/progress-overview'
import { t } from 'ember-intl'
import { TaskState } from 'teacher-ui-client/components/task-state'
import { ThemeKeys } from 'teacher-ui-client/utils/themes'
import { StudentDashboardSubheader } from 'teacher-ui-client/components/tiles/student-dashboard/subheader'
import { DashboardStudentProgressEvents } from 'teacher-ui-client/components/reporting/mathseeds-prime/dashboard-student/progress-events'
import { FidgetSpinnerWaveComponent } from '@blakeelearning/fidget/components/fidget/spinner/wave'
import { and, lt, lte } from 'ember-truth-helpers'
import { on } from '@ember/modifier'
import { fn } from '@ember/helper'
import { optional } from 'teacher-ui-client/helpers/optional'
import type ReportingUiScopeMathseedsPrimeDashboardStudentIndexRoute from 'teacher-ui-client/reporting/ui-scope/mathseeds-prime/dashboard-student/index/route'

interface Args {
  model: ModelFor<ReportingUiScopeMathseedsPrimeDashboardStudentIndexRoute>
}

interface Signature {
  Args: Args
}
export const MathseedsPrimeDashboardStudentPage: TOC<Signature> = <template>
  <StudentDashboardTile
    data-test-progress-overview-tile
    @title={{t "pages.reporting.mathseedsPrime.dashboard.student.progressTile.title"}}
    @tooltipTitle={{t "pages.reporting.mathseedsPrime.dashboard.student.progressTile.tooltip"}}
    @icon="phosphor-share-network-fill"
    @theme={{ThemeKeys.green}}
  >
    <TaskState @task={{@model.fetchProgressOverviewReportTask}} @initialLoadingClass="m-3" as |lastValue isRunning|>
      <DashboardStudentProgressOverview
        data-test-progress-overview-table
        class="w-full"
        @overviewData={{lastValue.overview}}
        @isLoading={{isRunning}}
      />
    </TaskState>
    <StudentDashboardSubheader>
      {{t "pages.reporting.mathseedsPrime.dashboard.student.progressTile.recentActivity"}}
    </StudentDashboardSubheader>
    <TaskState @task={{@model.fetchProgressEventsReportTask}} @initialLoadingClass="m-3" as |lastEvents isRunning|>
      <DashboardStudentProgressEvents
        data-test-progress-events-table
        class="w-full"
        @eventsData={{lastEvents.events}}
        @isLoading={{isRunning}}
      />
      <div class="text-center">
        {{#if isRunning}}
          {{! h-6 sets the height of the spinner to the same as the line-height of the button text (text-base, 1.5rem) }}
          {{! This avoids layout shifting while loading }}
          <div class="m-3 h-6">
            <FidgetSpinnerWaveComponent data-test-more-progress-events-loading @small={{true}} @centered={{true}} />
          </div>
        {{else if (and (lt lastEvents.events.length lastEvents.meta.total_entries) (lte lastEvents.events.length 20))}}
          <button
            data-test-progress-events-show-more
            type="button"
            class="text-ms-green-350 m-3 font-semibold"
            {{on "click" (fn (optional @model.loadMoreProgressEvents) lastEvents.events.length)}}
          >
            {{t "pages.reporting.mathseedsPrime.dashboard.student.progressTile.showMoreButton"}}
            <PhosphorIcon @icon="phosphor-caret-down-bold" />
          </button>
        {{/if}}
      </div>
    </TaskState>
  </StudentDashboardTile>
</template>

export default MathseedsPrimeDashboardStudentPage
